// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = require("!!../../../../css-loader/dist/cjs.js??clonedRuleSet-71.use[1]!../../../../postcss-loader/dist/cjs.js??clonedRuleSet-71.use[2]!../../../../postcss-loader/dist/cjs.js??clonedRuleSet-71.use[3]!../../../../sass-loader/dist/cjs.js??clonedRuleSet-71.use[4]!./VTabs.sass");
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = require("!../../../../vue-style-loader/lib/addStylesClient.js").default
var update = add("46f8106a", content, true, {"sourceMap":false,"shadowMode":false});